__turbopack_context__.v({
  "bounce": "LoadingCards-module-scss-module__ZhKNJG__bounce",
  "consumerEventLoadingCard": "LoadingCards-module-scss-module__ZhKNJG__consumerEventLoadingCard",
  "consumerEventLoadingCardAside": "LoadingCards-module-scss-module__ZhKNJG__consumerEventLoadingCardAside",
  "consumerEventLoadingCardItem": "LoadingCards-module-scss-module__ZhKNJG__consumerEventLoadingCardItem",
  "consumerEventLoadingCardMain": "LoadingCards-module-scss-module__ZhKNJG__consumerEventLoadingCardMain",
  "consumerLoadingCardsGrid": "LoadingCards-module-scss-module__ZhKNJG__consumerLoadingCardsGrid",
  "consumerLoadingCardsList": "LoadingCards-module-scss-module__ZhKNJG__consumerLoadingCardsList",
  "consumerLoadingCardsListFlipped": "LoadingCards-module-scss-module__ZhKNJG__consumerLoadingCardsListFlipped",
  "consumerLoadingCardsListResponsive": "LoadingCards-module-scss-module__ZhKNJG__consumerLoadingCardsListResponsive",
  "consumerLoadingCardsListResponsiveFlipped": "LoadingCards-module-scss-module__ZhKNJG__consumerLoadingCardsListResponsiveFlipped",
  "consumerLoadingCardsListSquare": "LoadingCards-module-scss-module__ZhKNJG__consumerLoadingCardsListSquare",
  "consumerLoadingCardsListSquareFlipped": "LoadingCards-module-scss-module__ZhKNJG__consumerLoadingCardsListSquareFlipped",
  "depress": "LoadingCards-module-scss-module__ZhKNJG__depress",
  "elevate": "LoadingCards-module-scss-module__ZhKNJG__elevate",
  "fadeIn": "LoadingCards-module-scss-module__ZhKNJG__fadeIn",
  "fadeInDown": "LoadingCards-module-scss-module__ZhKNJG__fadeInDown",
  "fadeInLeft": "LoadingCards-module-scss-module__ZhKNJG__fadeInLeft",
  "fadeInRight": "LoadingCards-module-scss-module__ZhKNJG__fadeInRight",
  "fadeInUp": "LoadingCards-module-scss-module__ZhKNJG__fadeInUp",
  "fadeOut": "LoadingCards-module-scss-module__ZhKNJG__fadeOut",
  "fadeOutDown": "LoadingCards-module-scss-module__ZhKNJG__fadeOutDown",
  "fadeOutUp": "LoadingCards-module-scss-module__ZhKNJG__fadeOutUp",
  "grow": "LoadingCards-module-scss-module__ZhKNJG__grow",
  "loadingCardSwipeX": "LoadingCards-module-scss-module__ZhKNJG__loadingCardSwipeX",
  "loadingCardSwipeY": "LoadingCards-module-scss-module__ZhKNJG__loadingCardSwipeY",
  "moveIn": "LoadingCards-module-scss-module__ZhKNJG__moveIn",
  "moveOut": "LoadingCards-module-scss-module__ZhKNJG__moveOut",
  "pop": "LoadingCards-module-scss-module__ZhKNJG__pop",
  "root": "LoadingCards-module-scss-module__ZhKNJG__root",
  "rotate": "LoadingCards-module-scss-module__ZhKNJG__rotate",
  "rotateX": "LoadingCards-module-scss-module__ZhKNJG__rotateX",
  "rotateY": "LoadingCards-module-scss-module__ZhKNJG__rotateY",
  "shake": "LoadingCards-module-scss-module__ZhKNJG__shake",
  "shorten": "LoadingCards-module-scss-module__ZhKNJG__shorten",
  "slideUp": "LoadingCards-module-scss-module__ZhKNJG__slideUp",
});
